<section class="content">
  <div class="card" style="padding: 50px;">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="form-row">
      <div class="col">
        <label style="font-size: 15px;">Enter Customer and Search <i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control" [(ngModel)]="icustomer_code" id="customer_code"
          (keydown)="eventEmitClickedOnCustmerCode($event, 'code')"
          style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;">
      </div>
      <div class="col-1 text-center" style="font-size: 28px; margin-top: 3%;">or</div>
      <div class="col">
        <label style="font-size: 15px;">Enter Customer Phone number and Search <i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="text" class="form-control" [(ngModel)]="icustomer_mobile"
          (keydown)="eventEmitClickedOnCustmerPhone($event, 'phone_number')" id="customer_phone_number"
          style="padding: 5px; border-bottom: none; border: 3px solid black; border-radius: 5px; ;height: 68%; font-size: 20px;">
      </div>
      <div class="col">
        <button mat-raised-button color="primary" class="button-class"
          style="margin-left: 10%;margin-top: 13%;font-size: 20px;" (click)="getIcustomerDetails()"
          [disabled]="icustomer_code == null && icustomer_mobile == null">Search
        </button>
      </div>
    </div>

    <div *ngIf="icustomer_verified" style="padding: 13px;margin-bottom: 51px;">
      <div class="row">
        <div class="col-7"
          style="margin-top: 15px; text-align: center; border: 2px solid grey; padding: 15px; border-radius: 10px; background: floralwhite;">
          <h4>Orders</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-7">
          <div class="card" *ngFor="let date_value of future_order,  let title_index=index;" style="margin-top: 10px;">
            <div style="padding: 5px;width: 100%;margin-top: 10px;" *ngIf="date_value['total_price_per_month']!= null"
              (click)="routeToDetailPage(date_value, title_index)">
              <span>
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col">
                    <label style="font-weight: 600;">
                      {{monthNames[date_value['month'] - 1]}} {{date_value['year']}}</label>
                  </div>
                  <div class="col">
                    <label>Total Bill amount : <span style="font-weight: 600;">
                        {{date_value['total_price_per_month']}} </span></label>
                  </div>
                  <div class="col">
                    <label> Ordered Date : <b>{{date_value['order_date']| date: 'MMM, d'}}</b></label>
                  </div>
                  <div class="col-1">
                    <i class="material-icons" *ngIf="selected_index !== title_index">keyboard_arrow_down</i>
                    <i class="material-icons" *ngIf="selected_index === title_index">keyboard_arrow_up</i>
                  </div>
                </div>
              </span>
            </div>
            <span *ngIf="selected_index === title_index">
              <div class="card" *ngIf="product_form_dict_for_future_order!= null" style="padding: 5px;color: black;">
                <div class="row" style="padding: 10px;">
                  <div class="col-1"></div>
                  <div class="col">
                    <b style="font-size: 18px; text-decoration: underline;">Order Details</b></div>
                </div>
                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-5" *ngIf="month_and_year != null">
                    {{monthNames[month_and_year['month'] - 1]}} {{total_days_in_month}} days
                  </div>
                </div>
                <div class="row" style="text-align: center;">
                  <div class="col-1"></div>
                  <div class="col-3"></div>
                  <div class="col-2 text-center" *ngFor="let session of session_list">
                    {{session['display_name']}}
                  </div>
                  <div class="col-3 text-center">
                    <label> Price<br>(Per month)</label>
                  </div>
                </div>
                <span>
                  <span *ngFor="let product of product_list">
                    <div class="row"
                      *ngIf="icustomer_type_id == 2 && old_employee_product_list.includes(product.product_id)">
                      <div class="col-1"></div>
                      <div class="col-3">
                        {{product.product_short_name}}<br>
                      </div>
                      <div class="col-2 text-center" *ngFor="let session of session_list">
                        <label
                          *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] !== null">
                          {{product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity']}}</label>
                        <label
                          *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] == null">
                          0
                        </label>
                      </div>
                      <div class="col-3 text-center" style="text-align: left;">
                        <label style="margin-left: 5%;">
                          {{product_form_dict_for_future_order['total_price_per_product_per_month'][product.product_id]}}
                        </label>
                      </div>
                    </div>
                    <div class="row" *ngIf="icustomer_type_id != 2">
                      <div class="col-1"></div>
                      <div class="col-3">
                        {{product.product_short_name}} <br>
                      </div>
                      <div class="col-2 text-center" *ngFor="let session of session_list">
                        <label
                          *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] !== null">
                          {{product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity']}}</label>
                        <label
                          *ngIf="product_form_dict_for_future_order['product'][session.id][product.product_id]['quantity'] == null">
                          0
                        </label>
                      </div>
                      <div class="col-3 text-center" style="text-align: left;">
                        <label style="margin-left: 5%;">
                          {{product_form_dict_for_future_order['total_price_per_product_per_month'][product.product_id]}}
                        </label>
                      </div>
                    </div>
                  </span>
                </span>
                <div class="row">
                  <div class="col-8" style="text-align: right;">
                    <label>Total price</label>
                  </div>
                  <div class="col-3 text-center" style="border-top: 1px solid; border-bottom: 1px solid;">
                    <label>{{product_form_dict_for_future_order['total_price_per_order'] | currency:'INR'}}</label>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="business_details_for_future!=null" style="padding: 10px;">
                <div class="col-1"></div>
                <div class="col">
                  <b>Booth Name : </b> {{business_details_for_future['name']}}<br>
                  <b> Agent Name : </b> {{business_details_for_future['agent_first_name']}}
                  {{business_details_for_future['agent_last_name']}}<br>
                  <b>Mobile : </b> {{business_details_for_future['agent_mobile_number']}}<br>
                  <b>Address : </b> {{business_details_for_future['address']}} ,
                  {{business_details_for_future['location_category_value']}} ,
                  {{business_details_for_future['location_category_name']}}
                </div>
                <div class="col-3"> <button mat-raised-button class="button-class"
                    *ngIf="changeButtonEnable(date_value['date'])"
                    (click)="boothChangeClicked('after_order')"
                    [disabled]="checkForBoothChangeButtonDisable()">Change</button></div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
